export default __webpack_public_path__ + "static/process-2-fd1aa3776d0103a9a41d64318b0f496f.jpg";